import script from "./CustomerRecordLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerRecordLayout.vue?vue&type=script&setup=true&lang=js"

import "./CustomerRecordLayout.vue?vue&type=style&index=0&id=1b288cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b288cd0"]])

export default __exports__

/* vue-cli-plugin-import-components */

import ConversationsMenu from "@/components/customers/ConversationsMenu.vue";
import CustomerProfileHeader from "@/components/customers/CustomerProfileHeader.vue";
import CustomerTabBar from "@/components/customers/CustomerTabBar.vue";
import NeueOrderModal from "@/components/NeueOrderModal.vue";
import NewContactModal from "@/components/neue/NewContactModal.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
script.components = Object.assign({}, { ConversationsMenu, CustomerProfileHeader, CustomerTabBar, NeueOrderModal, NewContactModal, SecondaryNav }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConversationsMenu, CustomerProfileHeader, CustomerTabBar, NeueOrderModal, NewContactModal, SecondaryNav }, script.__o.components);}